// src/pages/Benefits.jsx
import "./Benefits.css";
import { Link } from "react-router-dom";
import React, { useEffect } from "react";

const Benefits = () => {
    const checkoutUrl = "https://learn.forgeyourpeak.in/web/checkout/698a8ef1831f481067f8b8f1";
    useEffect(() => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}, []);
  return (
    <div className="wrap">

      {/* HERO */}
      <div className="hero">
        <div className="kicker">
          BENEFITS • <b>ON-FIELD TRANSFER</b>
        </div>

        <h1>
          Sharper Visual Input.<br />
          Faster Decisions.<br />
          Cleaner Execution.
        </h1>

        <p className="sub">
          ForgeYourPeak improves the <b>performance loop</b> — how quickly and accurately you see, process, decide, and execute under pressure.
          These are the benefits athletes feel in training <i>and</i> in matches.
        </p>

        <div className="ctaRow">
          <Link className="btn primary" to="/webinar">
             Join Free Webinar</Link>
          <Link to="https://learn.forgeyourpeak.in/web/checkout/699d2e578d1a96e994ef9f47" className="btn" target="_blank" rel="noopener noreferrer">
            Join Ignite 
          </Link>
        </div>
      </div>

      {/* QUICK OUTCOMES */}
      <div className="section">
        <div className="pad">
          <h2>What Improves First</h2>
          <p className="muted">
            Early wins you can notice quickly when you train the right inputs.
          </p>

          <div className="stats">
            <div className="stat">
              <b>Clarity Under Speed</b>
              <div className="big">See earlier</div>
              <p>Cleaner pickup of ball/space/movement under pace.</p>
            </div>

            <div className="stat">
              <b>Reaction Efficiency</b>
              <div className="big">Move sooner</div>
              <p>Less delay between seeing the cue and initiating action.</p>
            </div>

            <div className="stat">
              <b>Decision Stability</b>
              <div className="big">Choose better</div>
              <p>Fewer rushed decisions when pressure rises.</p>
            </div>

            <div className="stat">
              <b>Consistency</b>
              <div className="big">Repeat form</div>
              <p>More reliable output across sessions and match situations.</p>
            </div>
          </div>
        </div>
      </div>
      {/* PERFORMANCE BENEFITS GRID */}
        <div className="section">
        <div className="pad">
            <h2>Performance Benefits</h2>
            <p className="muted">
            Practical outcomes mapped to what athletes actually care about.
            </p>

            <div className="benefits-grid">

            <div className="benefit-card">
                <div className="tag">VISION</div>
                <h3>Earlier Cue Pickup</h3>
                <p>
                Spot the ball, spacing, and movement earlier so your response starts sooner.
                </p>
            </div>

            <div className="benefit-card">
                <div className="tag">HAND-EYE</div>
                <h3>Better Timing & Contact</h3>
                <p>
                Cleaner coordination loop → improved execution at game speed.
                </p>
            </div>

            <div className="benefit-card">
                <div className="tag">MEMORY</div>
                <h3>Faster Pattern Recall</h3>
                <p>
                Recall patterns quickly so your decisions stay stable under stress.
                </p>
            </div>

            <div className="benefit-card">
                <div className="tag">ANTICIPATION</div>
                <h3>Quicker Reads</h3>
                <p>
                Pick up micro-cues earlier and improve prediction accuracy.
                </p>
            </div>

            <div className="benefit-card">
                <div className="tag">SLEEP</div>
                <h3>Better Recovery & Learning</h3>
                <p>
                Sleep supports skill acquisition, speed, focus and consistency.
                </p>
            </div>

            <div className="benefit-card">
                <div className="tag">FOCUS</div>
                <h3>Perform Under Pressure</h3>
                <p>
                Improve attention control so you execute even when stakes rise.
                </p>
            </div>

            </div>
        </div>
        </div>
        {/* BENEFITS BY PILLAR SECTION */}
<div className="section light-bg">
  <div className="pad">
    <h2>Benefits by Pillar</h2>
    <p className="muted">
      What each pillar improves — in simple, athlete-language.
    </p>

    <div className="pillar-wrapper">

      {/* Vision */}
      <div className="pillar-card">
        <div className="pillar-header">
          <h3>Vision</h3>
          <span>clarity • tracking • depth • focus</span>
        </div>
        <ul>
          <li>Earlier and cleaner visual pickup</li>
          <li>Improved tracking stability at pace</li>
          <li>Better depth judgement (timing + spacing)</li>
          <li>Reduced visual fatigue during long sessions</li>
        </ul>
      </div>

      {/* Hand-Eye */}
      <div className="pillar-card">
        <div className="pillar-header">
          <h3>Hand–Eye Coordination</h3>
          <span>timing • control • execution</span>
        </div>
        <ul>
          <li>Shorter cue-to-action latency</li>
          <li>Better rhythm, timing, and interception</li>
          <li>Cleaner execution at higher speed</li>
          <li>Fewer "late" mistakes under pressure</li>
        </ul>
      </div>

      {/* Memory */}
      <div className="pillar-card">
        <div className="pillar-header">
          <h3>Memory</h3>
          <span>working memory • recall • stability</span>
        </div>
        <ul>
          <li>Faster pattern recognition and recall</li>
          <li>Better retention from training</li>
          <li>Stable decisions when fatigued</li>
          <li>Improved consistency across sessions</li>
        </ul>
      </div>

      {/* Anticipation */}
      <div className="pillar-card">
        <div className="pillar-header">
          <h3>Anticipation</h3>
          <span>cue reading • prediction • speed</span>
        </div>
        <ul>
          <li>Improved cue pickup timing</li>
          <li>Faster decisions without rushing</li>
          <li>Better first-step initiation</li>
          <li>Less hesitation in match moments</li>
        </ul>
      </div>

      {/* Sleep */}
      <div className="pillar-card">
        <div className="pillar-header">
          <h3>Sleep & Recovery</h3>
          <span>reset • learning • repeatability</span>
        </div>
        <ul>
          <li>Better learning and skill consolidation</li>
          <li>Improved reaction speed and focus</li>
          <li>Reduced burnout and fatigue buildup</li>
          <li>More consistent weekly performance</li>
        </ul>
      </div>

    </div>
  </div>
</div>
       {/* ================= HOW THIS SHOWS UP ================= */}

<div className="section light-bg">
  <div className="pad">

    <h2 className="matches-title">How This Shows Up in Matches</h2>
    <p className="matches-sub">
      Real “felt” changes athletes report when the loop improves.
    </p>

    <div className="matches-grid">

      {/* LEFT CARD */}
      <div className="matches-card">
        <div className="matches-header">You’ll notice</div>
        <ul>
          <li>The game feels a fraction slower</li>
          <li>You read situations earlier</li>
          <li>You commit to decisions faster</li>
          <li>You make fewer late adjustments</li>
          <li>You stay locked in longer</li>
        </ul>
      </div>

      {/* RIGHT CARD */}
      <div className="matches-card">
        <div className="matches-header">Which leads to</div>
        <ul>
          <li>Better timing and execution</li>
          <li>Higher quality repetitions in training</li>
          <li>More consistent match output</li>
          <li>Improved confidence under pressure</li>
          <li>Cleaner learning curve over a season</li>
        </ul>
      </div>

    </div>
  </div>
</div>

      {/* FINAL CTA */}
      <div className="section final">
        <div className="pad">
          <h2>Start Small. Build the System.</h2>
          <p className="muted">
            Bootcamp is your entry into structured neuro-performance training.
            Ignite takes it deeper.
          </p>

          <div className="ctaRow">
            <button className="btn primary" onClick={() => window.open(checkoutUrl, "_blank")}>Start Bootcamp (₹499)</button>
            <Link to="https://learn.forgeyourpeak.in/web/checkout/699d2e578d1a96e994ef9f47" className="btn" target="_blank" rel="noopener noreferrer">
              Join Ignite 
            </Link>
          </div>

          
        </div>
      </div>

      <div className="footer">© ForgeYourPeak • Benefits</div>

    </div>
  );
};

export default Benefits;